module.exports = "query ($id: ID!) {\n  Project(id: $id) {\n    metadata {\n      residentialNumberSuggestion\n      remainingUnits\n    }\n  }\n}\n"